import { Injectable } from '@angular/core';
import { forkJoin, Observable} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Xmldefs } from '../../../../../../core/entities/xmldefs.model';
import { XmldefsService } from '../../../../../../core/repositories/xmldefs.service';
import { InternalHomeService } from '../../../../internal-home/internal-home.service';
import { Xmlfields } from '../../../../../../core/entities/xmlfields.model';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Fieldtypes } from 'src/app/core/entities/fieldtypes.model';


@Injectable()
export class CampsService {

  xmldefs: Xmldefs = new Xmldefs();
  originalXmldefs: Xmldefs = new Xmldefs();
  optionsXmlfields: Xmlfields[] = new Array<Xmlfields>();

  allXmldefs: Xmldefs[] = [];
  changetitulo: boolean = false;
  idXmldefs: number = 0;

  titles: Xmlfields[] = new Array<Xmlfields>();

  constructor(private xmldefsService: XmldefsService,
              private internalHomeService: InternalHomeService,
              private dialog: MatDialog,
              private translateService: TranslateService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.xmldefs = data.xmldef;
    this.changetitulo = data.titulochange;
    this.idXmldefs = data.xmldef.id;

    if(this.xmldefs.title1 === null){
      this.xmldefs.title1 = {id: 0, code: "", desc: "", fieldtypeId: new Fieldtypes(), xmldefId: 0, numorder: 0, fieldsize : 0, cat: "", esp: "", visibility :0}
      this.xmldefs.title2 = {id: 0, code: "", desc: "", fieldtypeId: new Fieldtypes(), xmldefId: 0, numorder: 0, fieldsize : 0, cat: "", esp: "", visibility :0}
    }

    this.originalXmldefs = _.cloneDeep(this.xmldefs);
    console.log(data);

    return forkJoin({
        valor0: this.internalHomeService.allXmlfields(),
        valor1: this.xmldefsService.findAll()
    }).pipe(map(dataGroup => {

      this.titles = dataGroup.valor0;
      this.allXmldefs = dataGroup.valor1 as Xmldefs[];

      for(let i = 0; i < this.titles.length; i++){
        if(this.xmldefs.id === this.titles[i].xmldefId){
          this.optionsXmlfields.push(this.titles[i]);
        }
      }

      console.log(this.optionsXmlfields);
      return true;
      
    }),catchError((error: any) => {
      throw error;
    }));
  }

  build() {
    this.optionsXmlfields = new Array<Xmlfields>();
  }

}
